<div class="modal fade"
     bsModal
     #addFilingModal="bs-modal"
     [config]="{backdrop: true}"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     (onShow)="showModalInit()">
    @if (newFiling) {
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <ws-modal-wrapper headerLabel="New Compliance Filing"
                                  acceptLabel="Add"
                                  [disableSave]="!newFiling.description || creatingFiling"
                                  (save)="save()"
                                  (cancel)="addFilingModal.hide()">
                    <div class="row">
                        <div class="col-8">
                            <label>
                                <span>Filing Type:</span>
                                <select class="form-select form-select-sm" [(ngModel)]="newFiling.filingTypeId" style="width: 200px;"
                                        (change)="filingTypeChanged()">
                                    @for (type of filingTypesDropdown; track type) {
                                        <option [ngValue]="type.filingTypeId">{{ type.name }}</option>
                                    }
                                </select>
                            </label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <label>
                                <span>Description:</span>
                                <input class="form-control" type="text" [(ngModel)]="newFiling.description" style="width: 200px;">
                            </label>
                        </div>
                    </div>
                </ws-modal-wrapper>
            </div>
        </div>
    }
</div>
